import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../../Components/Layout";
import Attendee from "../../../Components/OrderMgt/Attendee/Attendee";
import useHttpHook from "../../../Hooks/HttpHook";
import {
  GetAllAttendees,
  GetAllCancelRequests,
  OrganizerEventApi,
} from "../../../utils/ApiConstant";
import { OrderLanguage } from "../../../utils/Languages";
import AttendeeStepper from "../../../Components/OrderMgt/Attendee/AttendeeStepper";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const AttendeeListPage = () => {
  const [attendeeList, setAttendeeList] = useState(null);
  const [loading, sendRequest, error] = useHttpHook();
  const [events, setEvents] = useState({ itemsList: [] });
  const [selectedEvent, setSelectedEvent] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [cancleRequests, setCancleRequests] = useState(null);

  const query = new URLSearchParams(window.location.search);
  const event = query.get("event");
  const navigate = useNavigate();

  useEffect(() => {
    getCancleTicketRequests();
    if (event !== null) {
      setSelectedEvent(event);
    }
  }, []);

  useEffect(() => {
    getEventsOfOrganizer();
  }, []);

  useEffect(() => {
    if (event !== null && selectedEvent !== event) {
      return;
    }
    getList(1);
  }, [selectedEvent, searchInput]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const getEventsOfOrganizer = async () => {
    try {
      const response = await sendRequest(OrganizerEventApi, {
        method: "get",
      });
      setEvents(response.data || { itemsList: [] });
    } catch (fetchError) {
      console.log(fetchError);
    }
  };

  const getList = async (page = 1) => {
    if (searchInput.length > 0 && searchInput.length < 3) {
      return;
    }
    try {
      const response = await sendRequest(
        `${GetAllAttendees}?page=${page}` +
          (selectedEvent ? `&event=${selectedEvent}` : "") +
          (searchInput?.length > 0 ? `&q=${encodeURIComponent(searchInput)}` : ""),
        {
          method: "get",
        }
      );
      if (page === 1) {
        setAttendeeList(response);
      } else {
        setAttendeeList((prevState) =>
          createObjectForPaginatedResult(response, prevState, "paginate")
        );
      }
    } catch (fetchError) {
      console.log(fetchError);
    }
  };

  const getCancleTicketRequests = async (page = 1) => {
    try {
      const response = await sendRequest(`${GetAllCancelRequests}?page=${page}`, {
        method: "get",
      });
      if (page === 1) {
        setCancleRequests(response);
      }
    } catch (fetchError) {
      console.log(fetchError);
    }
  };

  const handleSelect = (eventId) => {
    if (eventId) {
      navigate(`/organizer/attendees?event=${eventId}`);
    } else {
      navigate("/organizer/attendees");
    }
    setSelectedEvent(eventId);
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const FilterComponent = () => (
    <div className="event-attendees-filter-field">
      <label className="visually-hidden" htmlFor="eventAttendeesEventFilter">
        Event name
      </label>
      <select
        id="eventAttendeesEventFilter"
        className="event-attendees-event-select"
        value={selectedEvent || ""}
        onChange={(e) => handleSelect(e.target.value)}
      >
        <option value="">Select Event Name</option>
        {events.itemsList?.map((eventItem) => (
          <option key={eventItem._id} value={eventItem._id}>
            {eventItem.title}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <Layout
      Heading={OrderLanguage.Attendees.heading}
      TitleMark={true}
      TitleMarkClassName="event-attendees-title-mark"
      TitleClassName="event-attendees-title"
      HeadClassName="event-page-head event-create-head event-create-head--split event-attendees-head"
      CreateHead
      ExtraclassName="event-attendees-panel"
      activeMenuId="attendees"
      extraElement={<FilterComponent />}
    >
      <div className="event-attendees-body">
        <AttendeeStepper
          attendees={attendeeList?.data?.paginator?.itemCount}
          cancleRequests={cancleRequests?.data?.paginator?.itemCount}
        />
        <Attendee
          isLoading={loading}
          isError={error}
          list={attendeeList}
          getList={getList}
          handleSearchChange={handleSearchChange}
          searchInput={searchInput}
        />
      </div>
    </Layout>
  );
};

export default AttendeeListPage;
